import styled from 'styled-components';
import colors from '../../../theme/colors';
export var LinkStyle = /*#__PURE__*/styled.a.withConfig({
  componentId: "sc-1cf7u6r-0"
})(["display:inline-block;text-decoration:none;color:", ";&:active{color:", ";}"], colors.sea_normal, colors.sea_dark);